<div style="margin: 50px;">
    <h3 *ngIf="dataSource.data.length == 0">
        {{ 'features.katalogOrgana.pretraga.organizacionaStrukturaNijeDefinisana' | translate}}
    </h3>

    <mat-tree *ngIf="dataSource.data.length > 0" [dataSource]="dataSource" [treeControl]="treeControl">
       <!-- This is the tree node template for leaf nodes  -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
            <button mat-icon-button [disabled]="true">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{'chevron_right'}}</mat-icon>
              </button> {{node.name}}
        </mat-tree-node>
       <!-- This is the tree node template for expandable nodes  -->
        <mat-tree-node *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding>
            <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                <mat-icon class="mat-icon-rtl-mirror">
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
            {{node.name}}
        </mat-tree-node>
    </mat-tree>
</div>
